export const SET_AUTH = 'SET_AUTH'
export const REMOVE_AUTH = 'REMOVE_AUTH'
